import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dq-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  constructor() {}

  @Input()
  isFiltersVisible: boolean = true;

  ngOnInit(): void {}
}
